'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.LoaderLabelPositions = void 0;
(function(LoaderLabelPositions) {
    LoaderLabelPositions["Bottom"] = 'bottom';
    LoaderLabelPositions["Right"] = 'right';
})(exports.LoaderLabelPositions || (exports.LoaderLabelPositions = {}));
exports.LoaderLabels = void 0;
(function(LoaderLabels) {
    LoaderLabels["Loading"] = "Loading";
    LoaderLabels["Saving"] = "Saving";
})(exports.LoaderLabels || (exports.LoaderLabels = {}));
exports.LoaderLooks = void 0;
(function(LoaderLooks) {
    LoaderLooks["Black"] = 'black';
    LoaderLooks["Gray"] = 'gray';
    LoaderLooks["Primary"] = 'primary';
    LoaderLooks["Warning"] = 'warning';
    LoaderLooks["White"] = 'white';
})(exports.LoaderLooks || (exports.LoaderLooks = {}));
exports.LoaderSizes = void 0;
(function(LoaderSizes) {
    LoaderSizes["Large"] = 'large';
    LoaderSizes["Medium"] = 'medium';
    LoaderSizes["Small"] = 'small';
})(exports.LoaderSizes || (exports.LoaderSizes = {}));
exports.ShimmerLoaderLooks = void 0;
(function(ShimmerLoaderLooks) {
    ShimmerLoaderLooks["Default"] = 'default';
})(exports.ShimmerLoaderLooks || (exports.ShimmerLoaderLooks = {}));
//# sourceMappingURL=loader.js.map
